import React from 'react';
import analyticsWrapper from 'components_library/utils/analyticsWrapper';
import Image from 'components_library/atoms/Image/Image';
import Link from 'components_library/atoms/Link/Link';
import s from './Banner.scss';

const Banner = props => {
  const { data } = props;
  if (!(data && data.imageSrc)) {
    return null;
  }
  const { imageSrc, lazyload, path, ga, placeholderType } = data;
  return (
    <div className={`${s.banner_placeholder} ${placeholderType}`}>
      <Link
        to={path}
        target="_blank"
        onClick={() => {
          if (ga && ga.type) {
            analyticsWrapper('ga4', {
              event: 'user_click',
              type: ga.type,
              category: 'story_click',
            });
          }
        }}
        isNoLink={!path}
      >
        <Image src={imageSrc} lazyload={lazyload} />
      </Link>
    </div>
  );
};

export default Banner;
